// extracted by mini-css-extract-plugin
export var badge = "df_jz";
export var caption = "df_fs";
export var header = "df_q";
export var headerWithHorizontalRule = "df_jw";
export var v1 = "df_jx";
export var v2 = "df_jy";